export type Color = 'white' | 'black';

export type PieceKind = 'man' | 'king';

export interface Piece {
  readonly color: Color;
  readonly kind: PieceKind;
}

export interface Square {
  readonly row: number;
  readonly col: number;
}

/**
 * A single legal turn. For a quiet move, `captures` is empty and `path` has
 * a single entry (the destination). For a capture chain, `captures` lists the
 * opponent pieces removed in chain order and `path` lists the intermediate
 * landing squares ending at `to`.
 */
export interface Move {
  readonly from: Square;
  readonly to: Square;
  readonly captures: readonly Square[];
  readonly path: readonly Square[];
  readonly promoted: boolean;
}

export function sameSquare(a: Square, b: Square): boolean {
  return a.row === b.row && a.col === b.col;
}

export function opponentOf(color: Color): Color {
  return color === 'white' ? 'black' : 'white';
}
